export const comments_3787341 = {"data":{"data":[],"links":{}}}